import Select, { components } from "react-select";
import React, { useState, useEffect, useContext, Fragment, useCallback, useMemo, useRef } from "react";
import "./style.css";
import { I18nContext } from "../../store/context/i18nContext";
import { Button } from "reactstrap";
import { buildAutomationChildTestId, resolveAutomationTestId } from "../InputField/testId";
import { withAutomationComponents } from "./automationComponents";


const fontSize = 14;

const Menu = (props) => {
  return (
    <Fragment>
      <components.Menu {...props} className="w-100">
        <div className="w-100">
          {props?.selectProps.fetchingData ? (
            <span className="fetching">Fetching data...</span>
          ) : (
            <div>{props?.children}</div>
          )}

          <div
            className={"change-data d-flex justify-content-center w-100 "}
            onClick={props?.selectProps.changeOptionsData}
          >
            {/* <props.selectProps.bottomBarChildren /> */}
          </div>


        </div>
      </components.Menu>
    </Fragment>
  );
};

export const SelectFieldMultiple = (props) => {
  const [showAddComponent, setShowAddComponent] = useState(false);
  const [onFocus, setOnFocus] = useState(false);
  const { t } = useContext(I18nContext);
  const fieldTestId = resolveAutomationTestId(props["data-testid"], props.id, props.name);
  const onChangeRef = useRef(props?.onChange);
  const selectedValue = useMemo(
    () => (Array.isArray(props?.value) ? props.value : []),
    [props?.value]
  );
  const hasSelectedValue = selectedValue.length > 0;

  useEffect(() => {
    onChangeRef.current = props?.onChange;
  }, [props?.onChange]);

  useEffect(() => {
    document
      .querySelectorAll(".css-yk16xz-control")
      .forEach((ele) => (ele.style.border = "none"));
  }, []);

  const renderLeftComponent = () => {
    if (!props?.LeftComponent) return null;
    return (
      <div
        data-testid={buildAutomationChildTestId(fieldTestId, "left")}
        onClick={(e) =>
          props?.onClickLeft ? props?.onClickLeft(e) : null
        }
        className={
          props?.onClickLeft
            ? "component_pointer Selectfield__leftComponent"
            : "selectfield__leftComponent"
        }
      >
        <props.LeftComponent />
      </div>
    )
  }

  const renderRightComponent = () => {
    if (!props?.RightComponent) return null;
    return (
      <div
        data-testid={buildAutomationChildTestId(fieldTestId, "right")}
        onClick={(e) =>
          props?.onClickRight ? props?.onClickRight(e) : null
        }
        style={{ position: "relative", top: -14 }}
        className={
          props?.onClickRight
            ? "component_pointer Selectfield__rightComponent"
            : "selectfield__rightComponent"
        }
      >
        <props.RightComponent />
      </div>
    )
  }

  const renderAddComponent = () => {
    if (!(showAddComponent && props?.flexible && props?.AddEntityComponent)) return null;
    return (
      <section
        data-testid={buildAutomationChildTestId(fieldTestId, "add-entity")}
        style={{
          height: "100vh",
          width: "100vw",
          backgroundColor: "white",
          position: "fixed",
          top: "0",
          left: "0",
          zIndex: "1500",
        }}
      >
        <props.AddEntityComponent setShowAddComponent={setShowAddComponent} />
      </section>
    )
  }

  const handleOnChange = useCallback((nextValue) => {
    if (typeof onChangeRef.current === "function") {
      onChangeRef.current(Array.isArray(nextValue) ? nextValue : []);
    }
  }, []);

  const selectComponents = useMemo(() => (
    hasSelectedValue
      ? {
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }
      : {
        IndicatorSeparator: () => null,
      }
  ), [hasSelectedValue]);

  const selectComponentsWithBottomBar = useMemo(() => (
    hasSelectedValue
      ? {
        IndicatorSeparator: () => null,
        components,
        Menu,
        DropdownIndicator: () => null,
      }
      : {
        IndicatorSeparator: () => null,
        Menu,
      }
  ), [hasSelectedValue]);

  return (
    <React.Fragment>
      <section
        data-testid={fieldTestId}
        className={`selectfield__wrapper ${props?.className}`}
      >


        {!(props?.plain || props?.outline || props?.inline) && (
          <div
            data-testid={buildAutomationChildTestId(fieldTestId, "label")}
            style={{ fontSize: 16, margin: "0px 0px 5px 5px", fontWeight: "500", display: "block", ...props?.labelStyle }}
          >
            {(props?.label)}
            {props?.required && <font color="red">*</font>}
          </div>
        )}

        <div style={props?.style}
          className={
            ` ${!(props?.plain || props?.outline || props?.inline) ? "d-flex justify-content-center align-items-center " : " "}      selectfield__container ` +
            (props?.plain && !onFocus ? "selectfield__plain " : "") +
            props?.containerClassName
          }
        >



          {props?.suggestion && (
            <b className="selectfield__suggestion" data-testid={buildAutomationChildTestId(fieldTestId, "suggestion")}>{props?.suggestion}</b>
          )}
          <div
            className={
              props?.borderNone
                ? "border-0 "
                : "" + "selectfield__innercontainer d-flex  flex-1 "
            }
          >
            {renderLeftComponent()}

            {props?.inline ? (
              <div className="input-group">
                <div className="input-group-text">
                  {t(props?.label)}
                </div>
                {props?.required && <font color="red">*</font>}
                <Select
                  inputId={props?.id || fieldTestId}
                  instanceId={props?.id || fieldTestId}
                  automationTestId={fieldTestId}
                  {...(props?.selectTheme ? { theme: props.selectTheme } : {})}
                  {...(props?.filterOption && { filterOption: props?.filterOption })}
                  menuPosition="fixed"
                  components={withAutomationComponents(selectComponents)}
                  value={selectedValue}
                  menuPlacement={"auto"}
                  // value={props?.data.filter((d) => d.value  ===  value)}
                  isClearable={props?.showClear}
                  onFocus={() => setOnFocus(true)}
                  onBlur={() => setOnFocus(false)}
                  options={props?.data}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={handleOnChange}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: "none",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      boxShadow: "none",
                    }),
                  }}
                  className="form-control px-0 py-0 rounded-right-1"
                  placeholder={"Select " + t(props?.placeholder)}
                  isDisabled={props?.isDisabled || false}
                />
              </div>
            ) : (
              <div className="selectfield_multiple">
                <Select
                  inputId={props?.id || fieldTestId}
                  instanceId={props?.id || fieldTestId}
                  automationTestId={fieldTestId}
                  {...(props?.selectTheme ? { theme: props.selectTheme } : {})}
                  {...(props?.filterOption && { filterOption: props?.filterOption })}

                  components={withAutomationComponents(
                    props?.showBottomBar
                      ? selectComponentsWithBottomBar
                      : selectComponents
                  )}
                  // bottomBarChildren={props?.bottomBarChildren}
                  menuPlacement={"auto"}
                  isDisabled={props?.isDisabled}
                  value={selectedValue}
                  // value={props?.data.filter((d) => d.value  ===  value)}
                  isClearable={props?.showClear}
                  onFocus={() => setOnFocus(true)}
                  onBlur={() => setOnFocus(false)}
                  options={props?.data}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={handleOnChange}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: 0,
                      boxShadow: "none",
                      minHeight: 34,
                      maxHeight: "max-content",
                      minHeight: 34,
                      height: "auto",
                      backgroundColor: "transparent !important",

                    }),
                    container: (base) => ({
                      ...base,
                      height: "max-content",
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      minHeight: 22,
                      height: "auto"
                    }),
                    valueContainer: (base) => ({ ...base, padding: 0, paddingLeft: "12px", alignItems: "start", backgroundColor: "transparent !important" }),
                    placeholder: (base) => ({
                      ...base,

                    }),
                    menu: (provided, state) => ({
                      ...provided,
                      width: state.selectProps.width,
                      color: state.selectProps.menuColor,
                    }),
                    input: (base) => ({
                      ...base,
                      margin: 0,

                    }),
                  }}
                  className="selectfield__select  "
                  placeholder={" "}
                />
                <label
                  className={
                    hasSelectedValue || onFocus
                      ? "selectfield__label px-2 selectfield_multi__notempty_input"
                      : "selectfield__label px-2"
                  }
                >
                  {t(props?.placeholder)}
                </label>
              </div>
            )}

            {renderRightComponent()}
          </div>

        </div>
        {props?.error && props?.showErr && (
          <em className="selectfield__error" data-testid={buildAutomationChildTestId(fieldTestId, "error")}>{props?.error}</em>
        )}
        {props?.flexible && (
          <button data-testid={buildAutomationChildTestId(fieldTestId, "add")} onClick={() => setShowAddComponent(true)}>Add Entity</button>
        )}
      </section>
      {renderAddComponent()}
    </React.Fragment>
  );
};
